import LoadTagDataUtil from "@/modules/utils/loadTagDataUtil";
import AppConst from "@/modules/const";

/**
 * トラッキング処理系Class。
 */
export default class TrackingLoader {
	/**
	 * POSTリクエスト等でトラッキング処理を行うため、ReviCo Cookieを発行する。
	 */
	static trackingLoad(): void {
		// 本体側の`revico_tracking.js`をマウントさせ、読み込ませることでReviCo Cookieを発行
		// 既に`revico_tracking.js`がマウントされていたら処理は行わない
		/*
			NOTE:
			現状は「1つでも`revico_tracking.js`がマウントされていたら処理をしない」様になっている都合上、
			`tenantId`が異なる2つの貼り付けタグを同一ページに貼った場合、どちらか片方のテナントのReviCo Cookieしか発行されない。
			このため、本来であれば「既にマウントされた`revico_tracking.js`の貼り付けタグが持つ`tenantId`」までチェックする必要があるが…。
			`tenantId`が異なる2つの貼り付けタグを同一ページに貼る場合は特殊ケースなため、本対応は見送る。
		 */
		if (document.querySelector("script.revico-tracking")) {
			return;
		}

		// テナントIDを取得
		const element = document.querySelector<HTMLElement>(AppConst.COMMUNITY_TALK_TAG);
		const tenantId = LoadTagDataUtil.loadTenantId(element);

		// 本体側の`revico_tracking.js`をマウントさせる
		const script = document.createElement("script");
		script.src = `${process.env.VUE_APP_REVICO_FRONT_ENDPOINT}/providejs/revico_tracking.js`;
		script.type = "text/javascript";
		script.charset = "utf-8";
		script.classList.add("revico-tracking");
		script.dataset.revicoTenantid = tenantId;
		script.async = true;
		document.body.appendChild(script);
	}
}
